import { buttonClick } from '@emico-utils/datalayer-templates'

import dataLayer from './dataLayer'

const pushButtonClick = (buttonName?: string, buttonContext?: string) => {
  dataLayer.push(...buttonClick(buttonName, buttonContext))
}

export default pushButtonClick
